import styled from "styled-components";
export const CommerceCompassStyled = styled.div`
	.thank-you-page-content {
		display: flex;
	}
	.submmit-another {
		color: rgb(12, 100, 192);
	}
	width: 1142px;
	max-width: 90%;
	margin: 0 auto;
`;

export const ThankPage = styled.div`
	font-size: 0.875rem;
	padding: 20px;
	margin: 20px 0;
	.thank-you-page-reload-link {
		display: flex;
		gap: 10px;
	}
	.thank-you-page-container {
		margin-bottom: 20px;
	}
	.linkified {
		color: rgba(37, 99, 235);
	}
`;
